module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Mes projets")]), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.projects), function(project) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.$emit('showView', {
            view: 'ProjectDetails',
            params: {
              project: project
            }
          })
        }
      }
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v(_vm._s(project.name))])])])
  }), 0), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('showView', 'ProjectCreator')
      }
    }
  }, [_vm._v("démarrer un nouveau projet")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02f30d92!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create/ProjectList.vue
// module id = 580
// module chunks = 2